export default {
  title: {
    en: 'Get more for less',
  },
  text: {
    en: `
      Upgrade to two or three bottles a month to discover more scents and save money and get perfumes earlier.
      You queue will refill automatically.
    `,
  },
}
